import App from './app';

export default {
  'new-session': function(data) {
    App.router.navigate('#snippet', {trigger: true});
  }
};
